// extracted by mini-css-extract-plugin
module.exports = {"Component":"DataTableListGift_Component__3rifk"};